export default __webpack_public_path__ + "a85184f3b3b7270c8bdb2c4fa6fec5a2.png";